import Vue from 'vue';
import utils from "../../plugins/utils.js";
import zh_CN from './vee_validate_zh_CN.js';

import VeeValidate,{ Validator }  from 'vee-validate';
Vue.use(VeeValidate);

Validator.localize('zh_CN', zh_CN);

//自定义全局通用校验规则
Validator.extend('mobile',{
    getMessage:()=>'请输入正确的手机号码',
    validate: value => {
        return value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value);
    }
});
Validator.extend('link_url',{
    getMessage:()=>'请输入正确的链接地址',
    validate: value => {
         return utils.isURL(value);
    }
});
Validator.extend('idcard',{
    getMessage:()=>'请输入正确的身份证号',
    validate: value => {
        return utils.validateIdCard(value);
    }
});
